import { notify } from '@affine/component';
import { WorkbenchService } from '@affine/core/modules/workbench/services/workbench';
import { WorkspaceService } from '@affine/core/modules/workspace';
import { I18n } from '@affine/i18n';
import { useService } from '@toeverything/infra';
import { useLayoutEffect } from 'react';

import { setActiveChatPanelView } from './chat-panel-host-registry';

/** One binding at the actual Workbench root, independent of hidden view mounts. */
export function ChatPanelActiveViewOwner() {
  const workbench = useService(WorkbenchService).workbench;
  const workspaceId = useService(WorkspaceService).workspace.id;
  useLayoutEffect(() => {
    const subscription = workbench.activeView$.subscribe(view => {
      // A view switch drops the previous view's picks; never silently.
      if (setActiveChatPanelView({ workspaceId, viewId: view.id }) > 0)
        notify.warning({
          title: I18n.t('com.streamlain.copilot.context.view-switch-cleared'),
        });
    });
    return () => {
      subscription.unsubscribe();
      setActiveChatPanelView(null);
    };
  }, [workbench, workspaceId]);
  return null;
}
